import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

let Bbps_category = () => {

  let [data, setData] = useState([]);
  let [count, setCount] = useState();
  let [indexs, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  let [opendata, setOpendata] = useState()

  let navigate = useNavigate();

  useEffect(() => {
    Start();
    Payment();
  }, []);

  let [fastag, setFastag] = useState()
  let [eel, setEel] = useState()
  let [ccc, setccc] = useState()
  let [predata, setpredata] = useState(0)
  let [insu, setInsu] = useState(0)
  let [ggs, setGgs] = useState(0)

  let [post, setPost] = useState(0)

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Payment = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "get",
        url: Base_url_bbbs + "/adminbbps/all_category",
      })
        .then((dat) => {
          setData(dat.data.data);
          console.log(dat.data.data, "datddddddddddddddddddddddddddddddddddddddd ");
        })
        .catch((ee) => {
          console.log(ee, "datddddddddddddddddddddddddddddddddddddddd ");
        });
    } catch (err) { }
  };


  let Apicall_fatt = async (re) => {
    let token = await localStorage.getItem("token");

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/adminbbps/category",
      data: {
        category: re,
        limit: 100,
        skip: 0
      },
    })
      .then((dat) => {
        console.log(dat.data, "Jssonddddddddddddddddddddddddddddddddddddddddd ");
        setccc(dat.data.data)
      })
      .catch((ee) => { });
  }


  const handlePageClick = async (event) => {
    console.log(event.selected);


    setIndex(event.selected);

    let token = await localStorage.getItem("token");

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/adminbbps/category",
      data: {
        category: eel,
        limit: 10,
        skip: event.selected
      },
    })
      .then((dat) => {
        setccc(dat.data.data)
        console.log(dat.data, "Jssonddddddddddddddddddddddddddddddddddddddddd ");

      })
      .catch((ee) => { });

  };

  let Submit1 = async (tt) => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/adminbbps/changeactive",
      data: { data : tt }, 
    })
      .then((dat) => {
        if(dat.data.status === true){
          window.location.reload();
        } else{
          alert("Failed")
        }
      })
      .catch((ee) => { alert("Failed")});
  }

  let Submit2 = async (tt) => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
      return;
    }

    let apicall = await axios({
      method: "post",
      url: Base_url_bbbs + "/adminbbps/fetchbiller",
      data: { data : tt }, 
    })
      .then((dat) => {
        console.log(dat.data, "Jssonddddddddddddddddddddddddddddddddddddddddd ");
        if(dat.data.status === true){
        alert("Success")
        }else{
          alert("Failed")
        }
      })
      .catch((ee) => { alert("Failed") });
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-8" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }} >
          <p style={{ fontWeight: '700', fontSize: 15, marginTop: 5 }} >All BBps Category</p>
          <div className="row mt-4 ">
            <div className="col-6" >
              {data?.map((re, index) => {

                return (
                  <div className="row" style={{ border: '1px solid rgb(216, 216, 216)' }} onClick={() => {
                    setCount(re.count)
                    setEel(re.name)
                    setIndex(0)
                    Apicall_fatt(re.name)
                  }} >
                    <div className="col-6" >
                      <p>{re.name}  </p>
                    </div>
                    <div className="col-6" >
                      <p>  {re.count}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="col-6 " >

              <div style={{ width: '100%', marginLeft: 20 }} >

                <div className="row" style={{ border: '1px solid rgb(216, 216, 216)' }} onClick={() => {

                }} >
                  <div className="col-2" >
                    <p> </p>
                  </div>
                  <div className="col-4" >
                    <p style={{ fontWeight: '700' }}>Biller name</p>
                  </div>
                  <div className="col-6" >
                    <p style={{ fontWeight: '700' }}>Biller Id</p>
                  </div>
                </div>
                {ccc?.map((re, index) => {

                  return (
                    <div className="row" style={{ border: '1px solid rgb(216, 216, 216)' }} onClick={() => {

                      console.log(re)
                      setOpendata(re)
                      setIsOpen(true)
                    }} >
                      <div className="col-2" >
                        <p>{index + indexs * 10 + 1}  </p>
                      </div>
                      <div className="col-4" >
                        <p>{re.billerName}  </p>
                      </div>
                      <div className="col-6" >
                        <div className="d-flex"  >
                          <p> {re.billerId}</p> {re.active === true ?
                            <div style={{ width: 10, height: 10, borderRadius: 50, backgroundColor: 'green', marginLeft: 10, marginTop: 10 }} ></div> : ""
                          }
                        </div>

                      </div>
                    </div>
                  );
                })}
              </div>

              <div style={{ marginTop: 20 }} >
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  pageCount={count / 10}
                  previousLabel="< previous"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination justify-content-center"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  forcePage={indexs}
                />
              </div>



            </div>


          </div>
        </div>
      </div>


      <div className={`side-panel ${isOpen ? "open" : ""}`}>
        <p
          style={{ textAlign: "right", padding: 10, cursor: "pointer" }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          X
        </p>
        <div className="panel-content">
          <p style={{ fontWeight: '700', fontSize: 17 }}>Biller Details</p>

          <p style={{ fontWeight: '500', fontSize: 14 }}>Biller Name : {opendata?.billerName}</p>
          <p style={{ fontWeight: '500', fontSize: 14 }}>Biller Category : {opendata?.billerCategory}</p>
          <p style={{ fontWeight: '500', fontSize: 14 }}>Biller ID : {opendata?.billerId}</p>

          <div className="row" >
            <div className="col-6" >
              <button onClick={()=>{
                Submit2(opendata)
              }} >Fetch Biller</button>
            </div>
            <div className="col-6" >
              <button onClick={()=>{
                Submit1(opendata)
              }} > {opendata?.active === false ? "Active" : "Deactive"}</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Bbps_category;
